"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDataRef = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
function mockDataRef(extra = {}) {
    return Object.assign({ serviceConnUid: 'fake0serviceConnUid', _$w_ref: true, dataType: constants_iso_1.DataRefDataType.RedisHash, namespace: '_$w_taskWip:fake0abc123:_$w_auxRequestData', key: 'fake0deed:decade0accede', sizeChars: 28312 }, extra);
}
exports.mockDataRef = mockDataRef;
//# sourceMappingURL=mock-data-ref.js.map